export default "__VITE_ASSET__7a7c2af4__"